var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66659 14.1666V6.83325M1.33325 8.16659V12.8333C1.33325 13.5696 1.93021 14.1666 2.66659 14.1666H11.6174C12.6046 14.1666 13.4441 13.4464 13.5942 12.4707L14.3121 7.80403C14.4985 6.59252 13.5611 5.49992 12.3354 5.49992H9.99992C9.63173 5.49992 9.33325 5.20144 9.33325 4.83325V2.47714C9.33325 1.56925 8.59726 0.833252 7.68936 0.833252C7.47281 0.833252 7.27657 0.960782 7.18862 1.15867L4.84254 6.43734C4.73554 6.6781 4.4968 6.83325 4.23334 6.83325H2.66659C1.93021 6.83325 1.33325 7.43021 1.33325 8.16659Z",
    stroke: "#10B981",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.1f204ab01775bbfc66c5790a60703de2.svg";
export { ForwardRef as ReactComponent };